import { DateString } from "@pentacode/openapi";
import { Issue } from "../../issues";

import { TimeResult } from "../../time";

//TODO: remove references to model.ts
import { BonusesBalance, TimeBalance, VacationBalance } from "../../model";
import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";

export class DailyResultsDTO {
    constructor(props: DailyResultsDTO) {
        safeAssign<DailyResultsDTO>(this, props);
    }

    @Expose()
    employeeId: number | undefined = undefined;

    @Expose()
    date: DateString;

    @Expose()
    bonusesBalance: Omit<BonusesBalance, "employeeId" | "from" | "to">;
    @Expose()
    timeBalance: Omit<TimeBalance, "employeeId" | "from" | "to">;
    @Expose()
    timeBalancePlanned: Omit<TimeBalance, "employeeId" | "from" | "to"> | null;
    @Expose()
    vacationBalance: Omit<VacationBalance, "employeeId" | "from" | "to">;

    @Expose()
    issues: Issue[] | null;

    @Expose()
    averages: {
        "13weeks": Pick<TimeResult, "base" | "bonuses" | "breaks">;
    };

    @Expose()
    results: {
        //TODO: thin these out
        total: TimeResult;
        work: TimeResult;
        adjustments: TimeResult;
        workPlanned?: TimeResult;
        absences: TimeResult;
    };
}
